module.exports = __webpack_public_path__ + "static/media/92net1.ea5eebe5.png";